module.exports = __webpack_public_path__ + "static/media/5.2677b73c.png";